<h3>{{ 'You are looking for more?' | translate }}</h3>
<p></p>
<div>
  <app-booking-type-simple [title]="'Buy more Tickets' | translate" (click)="onClickBuyMoreTickets()">
  </app-booking-type-simple>
</div>
